import { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { News } from '../types/News';

export const useNews = (limitCount: number | null = 5) => {
  const [news, setNews] = useState<News[]>([]);
  const [newsLoading, setNewsLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setNewsLoading(true);
        
        const newsRef = collection(db, 'news');
        
        // Récupérer toutes les actualités et filtrer côté client
        // Cette approche évite le besoin d'un index composite
        const q = query(
          newsRef,
          orderBy('publishDate', 'desc')
        );
        
        const querySnapshot = await getDocs(q);
        
        // Filtrer côté client pour obtenir seulement les actualités publiées
        let filteredDocs = querySnapshot.docs.filter(doc => {
          const data = doc.data();
          return data.isPublished === true;
        });

        if (limitCount !== null) {
          filteredDocs = filteredDocs.slice(0, limitCount);
        }
        
        if (filteredDocs.length > 0) {
          const newsData = filteredDocs.map(doc => {
            const data = doc.data();
            return {
              id: doc.id,
              ...data
            };
          }) as News[];
          
          setNews(newsData);
        } else {
          setNews([]);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des actualités:', error);
      } finally {
        setNewsLoading(false);
      }
    };

    fetchNews();
  }, []);

  return { news, newsLoading };
};
